import React, { useContext, createContext, useState } from 'react';
import { PropTypes } from 'prop-types';
import { useOrganizationAPI } from 'apiServices/organizationAPI';

const initialState = {
  isOpen: false,
  subjectId: 'Não Encontrado',
  pat_id: 'Não Encontrado',
  consentType: 'Não Encontrado',
  organization: [
    {
      resourse: 'Não encontrado',
    },
  ],
};

const NewConsentModalContext = createContext(initialState);

export function NewConsentModalContextProvider({ children }) {
  const [response] = useOrganizationAPI();
  const mockedOrganization = {
    resourceType: 'Bundle',
    id: '146ecb21-e2b8-453a-a8ac-b3673bcbc974',
    meta: {
      lastUpdated: '2022-11-07T15:36:36.061-03:00',
    },
    type: 'searchset',
    total: 41,
    link: [
      {
        relation: 'self',
        url: 'http://localhost:8081/hapi/fhir/Organization?_count=99&_elements=identifier%2Cname%2Calias',
      },
    ],
    entry: [
      {
        fullUrl: 'https://shrop.ehrrunner.com:8243/ehrrunner/fhir/Organization/2.16.840.1.113883.13.36-00001',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-00001',
          meta: {
            versionId: '2',
            lastUpdated: '2022-10-05T13:53:27.754+00:00',
            source: '#yekPdydBS4QiHT6e',
          },
          identifier: [
            {
              system: 'http://shrop.moh.gov.jm/fhir/r4/CodeSystem/Facility',
              value: '00001',
            },
          ],
          active: true,
          type: [
            {
              coding: [
                {
                  system: 'http://shrop.moh.gov.jm/fhir/r4/CodeSystem/FacilityType',
                  code: 'govt',
                  display: 'Government',
                },
              ],
            },
            {
              coding: [
                {
                  system: 'http://shrop.moh.gov.jm/fhir/r4/CodeSystem/FacilityManagement',
                  code: 'national',
                },
              ],
            },
            {
              coding: [
                {
                  system: 'http://shrop.moh.gov.jm/fhir/r4/CodeSystem/FacilityOwnership',
                  code: 'Public',
                },
              ],
            },
          ],
          name: 'Ministry of Health and Wellness',
          alias: [
            'Ministry of Health and Wellness',
          ],
          telecom: [
            {
              system: 'phone',
              value: '876-633-8172',
            },
          ],
          address: [
            {
              extension: [
                {
                  url: 'http://hl7.org/fhir/StructureDefinition/geolocation',
                  extension: [
                    {
                      url: 'latitude',
                      valueDecimal: 18.00845,
                    },
                    {
                      url: 'longitude',
                      valueDecimal: -76.78815,
                    },
                  ],
                },
              ],
              line: [
                '10-16 Grenada Cres, Kingston 5',
              ],
              state: 'Saint Andrew',
            },
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2006197',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2006197',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2006197',
            },
          ],
          name: 'Hospital Universitário Professor Alberto Antunes da Universidade Federal de Alagoas',
          alias: [
            'HUPAA-Ufal',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2017644',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2017644',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2017644',
            },
          ],
          name: 'Hospital Universitário Getúlio Vargas da Universidade Federal do Amazonas',
          alias: [
            'HUGV-Ufam',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0003816',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0003816',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0003816',
            },
          ],
          name: 'Hospital Universitário Professor Edgard Santos da Universidade Federal da Bahia',
          alias: [
            'Hupes-UFBA',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0004731',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0004731',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0004731',
            },
          ],
          name: 'Maternidade Climério de Oliveira da Universidade Federal da Bahia',
          alias: [
            'MCO-UFBA',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2481286',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2481286',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2481286',
            },
          ],
          name: 'Maternidade Escola Assis Chateaubriand da Universidade Federal do Ceará',
          alias: [
            'Meac-UFC',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2561492',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2561492',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2561492',
            },
          ],
          name: 'Hospital Universitário Walter Cantídio da Universidade Federal do Ceará',
          alias: [
            'HUWC-UFC',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0010510',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0010510',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0010510',
            },
          ],
          name: 'Hospital Universitário de Brasília da Universidade de Brasília',
          alias: [
            'HUB-UnB',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-4044916',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-4044916',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '4044916',
            },
          ],
          name: 'Hospital Universitário Cassiano Antonio Moraes da Universidade Federal do Espírito Santo',
          alias: [
            'Hucam-Ufes',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2338424',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2338424',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2338424',
            },
          ],
          name: 'Hospital das Clínicas da Universidade Federal de Goiás',
          alias: [
            'HC-UFG',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2726653',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2726653',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2726653',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal do Maranhão',
          alias: [
            'HU-UFMA',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0027049',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0027049',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0027049',
            },
          ],
          name: 'Hospital das Clínicas da Universidade Federal de Minas Gerais',
          alias: [
            'HC-UFMG',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2218798',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2218798',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2218798',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal de Juiz de Fora',
          alias: [
            'HU-UFJF',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2206595',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2206595',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2206595',
            },
          ],
          name: 'Hospital de Clínicas da Universidade Federal do Triângulo Mineiro',
          alias: [
            'HC-UFTM',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2146355',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2146355',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2146355',
            },
          ],
          name: 'Hospital de Clinicas de Uberlândia',
          alias: [
            'HC-UFU',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0009709',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0009709',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0009709',
            },
          ],
          name: 'Hospital Universitário Maria Aparecida Pedrossian da Universidade Federal de Mato Grosso do Sul',
          alias: [
            'Humap-UFMS',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2710935',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2710935',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2710935',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal da Grande Dourados',
          alias: [
            'HU-UFGD',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2655411',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2655411',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2655411',
            },
          ],
          name: 'Hospital Universitário Júlio Müller da Universidade Federal do Mato Grosso',
          alias: [
            'HUJM-UFMT',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2332981',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2332981',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2332981',
            },
          ],
          name: 'Complexo Hospitalar Universitário João de Barros Barreto da Universidade Federal do Pará',
          alias: [
            'CHUJBB-UFPA ',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2694751',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2694751',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2694751',
            },
          ],
          name: 'Complexo Hospitalar Universitário Bettina Ferro de Souza da Universidade Federal do Pará',
          alias: [
            'HUBFS-UFPA',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2504502',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2504502',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2504502',
            },
          ],
          name: 'Hospital Universitário Júlio Bandeira da Universidade Federal de Campina Grande',
          alias: [
            'HUJB-UFCG',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2676060',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2676060',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2676060',
            },
          ],
          name: 'Hospital Universitário Alcides Carneiro da Universidade Federal de Campina Grande',
          alias: [
            'HUAC - UFCG',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2400243',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2400243',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2400243',
            },
          ],
          name: 'Hospital Universitário Lauro Wanderley da Universidade Federal da Paraíba',
          alias: [
            'HULW-UFPB',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-6042414',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-6042414',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '6042414',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal do Vale do São Francisco',
          alias: [
            'HU-Univasf',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0000396',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0000396',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0000396',
            },
          ],
          name: 'Hospital das Clínicas da Universidade Federal de Pernambuco',
          alias: [
            'HC-UFPE',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-3285391',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-3285391',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '3285391',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal do Piauí',
          alias: [
            'HU-UFPI',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2384299',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2384299',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2384299',
            },
          ],
          name: 'Complexo do Hospital de Clínicas da Universidade Federal do Paraná ',
          alias: [
            'CHC-UFPR ',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2640244',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2640244',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2640244',
            },
          ],
          name: 'Maternidade Victor Ferreira do Amaral da Universidade Federal do Paraná ',
          alias: [
            'MVFA-UFPR',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0012505',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0012505',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0012505',
            },
          ],
          name: 'Hospital Universitário Antônio Pedro da Universidade Federal Fluminense',
          alias: [
            'Huap-UFF',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2295415',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2295415',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2295415',
            },
          ],
          name: 'Hospital Universitário Gaffrée e Guinle da Universidade Federal do Estado do Rio de Janeiro',
          alias: [
            'HUGG-Unirio',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2409208',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2409208',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2409208',
            },
          ],
          name: 'Maternidade Escola Januário Cicco da  Universidade Federal do Rio Grande do Norte',
          alias: [
            'Mejc-UFRN',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2653982',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2653982',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2653982',
            },
          ],
          name: 'Hospital Universitário Onofre Lopes da Universidade Federal do Rio Grande do Norte',
          alias: [
            'Huol-UFRN',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-4014111',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-4014111',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '4014111',
            },
          ],
          name: 'Hospital Universitário Ana Bezerra da Universidade Federal do Rio Grande do Norte',
          alias: [
            'Huab-UFRN',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2252694',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2252694',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2252694',
            },
          ],
          name: 'Hospital Escola da Universidade Federal de Pelotas',
          alias: [
            'HE-UFPel',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2707675',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2707675',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2707675',
            },
          ],
          name: 'Hospital Universitário Doutor Miguel Riet Corrêa Junior da Fundação Universidade Federal do Rio Grande',
          alias: [
            'HU-Furg',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-2244306',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-2244306',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '2244306',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal de Santa Maria',
          alias: [
            'HUSM-UFSM',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-3157245',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-3157245',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '3157245',
            },
          ],
          name: 'Hospital Universitário da Universidade de Santa Catarina',
          alias: [
            'HU-UFSC',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-0002534',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-0002534',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '0002534',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal de Sergipe',
          alias: [
            'HU-UFS',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-6568343',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-6568343',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '6568343',
            },
          ],
          name: 'Hospital Universitário de Lagarto da Universidade Federal de Sergipe',
          alias: [
            'HUL-UFS',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-5586348',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-5586348',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '5586348',
            },
          ],
          name: 'Hospital Universitário da Universidade Federal de São Carlos',
          alias: [
            'HU-UFScar',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.840.1.113883.13.36-3654826',
        resource: {
          resourceType: 'Organization',
          id: '2.16.840.1.113883.13.36-3654826',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T02:19:49.825-03:00',
            source: '#4UJQNvtpMkUamc9d',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.840.1.113883.13.36',
              value: '3654826',
            },
          ],
          name: 'Hospital de Doenças Tropicais da Universidade Federal de Tocantins',
          alias: [
            'HDT-UFT',
          ],
        },
        search: {
          mode: 'match',
        },
      },
      {
        fullUrl: 'http://localhost:8081/hapi/fhir/Organization/2.16.76.1.3.3-15126437000143',
        resource: {
          resourceType: 'Organization',
          id: '2.16.76.1.3.3-15126437000143',
          meta: {
            versionId: '1',
            lastUpdated: '2022-10-26T12:00:17.915-03:00',
            source: '#JW6VUGU7eRGEcAnD',
            tag: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v3-ObservationValue',
                code: 'SUBSETTED',
                display: 'Resource encoded in summary mode',
              },
            ],
          },
          identifier: [
            {
              system: 'urn:oid:2.16.76.1.3.3',
              value: '15126437000143',
            },
          ],
          name: 'Empresa Brasileira de Serviços Hospitalares',
          alias: [
            'EBSERH',
          ],
        },
        search: {
          mode: 'match',
        },
      },
    ],
  };
  const organizationList = response?.entry || mockedOrganization.entry;

  const [newConsentModalState, setNewConsentModalState] = useState(initialState);
  const [vigency, setVigency] = useState(30);

  return (
    <NewConsentModalContext.Provider
      value={{
        newConsentModalState,
        setNewConsentModalState,
        organizationList,
        vigency,
        setVigency,
      }}
    >
      {children}
    </NewConsentModalContext.Provider>
  );
}

export function useNewConsentModalContext() {
  return useContext(NewConsentModalContext);
}

NewConsentModalContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};
